/* eslint-disable react/destructuring-assignment
,no-prototype-builtins , prefer-destructuring,  jsx-a11y/label-has-associated-control, jam3/no-sanitizer-with-danger
*/
import React from 'react';
import myxss from './myxss';



const ComponentLabel = (props) => {
  const hasRequiredLabel =
    props.data.hasOwnProperty('required') &&
    props.data.required === true &&
    !props.read_only;
    const hasToltipsenable = props.data.hasOwnProperty('tooltips') &&  props.data.tooltips  &&  !props.read_only;
    const labelTooltip = props.data.labelTooltip 


    const hasLeftLabelenable = props.data.hasOwnProperty('leftLabel') &&  props.data.leftLabel  &&  !props.read_only;
    const hasRightLabelenable = props.data.hasOwnProperty('centerLabel') &&  props.data.centerL3abel  &&  !props.read_only;
    const hasCenterLabelenable = props.data.hasOwnProperty('rightLabel') &&  props.data.rightLabel  &&  !props.read_only;
    const leftLabelText = props.data.leftLabelText 
    const centerLabelText = props.data.centerLabelText 
    const rightLabelText = props.data.rightLabelText 


  const labelText = myxss.process(props.data.label);
  if (!labelText) {
    return null;
  }
  return (
    <label className={props.className || 'form-label'}>
      <span dangerouslySetInnerHTML={{ __html: labelText }} />
      {hasRequiredLabel && (
        <span className="label-required badge badge-danger">Required</span>
      )}
      {
        hasToltipsenable && (
          <strong className="fas fa-info-circle tooltip_v">
            <strong className="tooltiptext_v" title={labelTooltip}>{labelTooltip} </strong >
          </strong>
      )}
      {
        (hasRightLabelenable || hasLeftLabelenable || hasCenterLabelenable) && (
          <div className="align-position">
          <div className='d-flex justify-content-between' style={{ maxWidth:'330px',display:'flex', justifyContent:'space-between', fontFamily: 'VodafoneRg-Regular',fontSize:'0.8rem',marginTop:'1.5rem' }}>
          <span>{leftLabelText}</span>
           <span>{centerLabelText}</span>
           <span>{rightLabelText}</span>
          </div>
          </div>
      )}

    </label>
  );
};

export default ComponentLabel;
